export enum PersonalDetailsTestHooks {
  EmailAddressText = 'personal-details-email-address-text',
  FirstName = 'personal-details-first-name-text',
  Form = 'personal-details-form',
  LastName = 'personal-details-last-name-text',
  OverrideAddressSelectTypeAhead = 'personal-details-override-address-select-typeahead',
  TelephoneText = 'personal-details-telephone-text',
  Title = 'personal-details-title-select',
}
